module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 _.each(tabs, function (tab) { ;
__p += '\n\n        ';
 if (tab.get('name') === "Reporting") { ;
__p += '\n            ';
 if (window._zmags_reporting_tab) { ;
__p += '\n                <a id="zmags-reporting-tab" class="tab ' +
__e( tab.get('slug') ) +
'-tab" data-tab="' +
__e( tab.get('slug') ) +
'" href="#' +
__e( tab.get('href') ) +
'" style="display:inline-block;">\n                    ' +
__e( tab.get('name') ) +
' <sup>' +
__e( tab.get('callout') ) +
'</sup>\n                </a>\n             ';
 } else { ;
__p += '\n                <a id="zmags-reporting-tab" class="tab ' +
__e( tab.get('slug') ) +
'-tab" data-tab="' +
__e( tab.get('slug') ) +
'" href="#' +
__e( tab.get('href') ) +
'" style="display:none;">\n                    ' +
__e( tab.get('name') ) +
' <sup>' +
__e( tab.get('callout') ) +
'</sup>\n                </a>\n             ';
 } ;
__p += '\n        ';
 } else { ;
__p += '\n            <a class="tab ' +
__e( tab.get('slug') ) +
'-tab" data-tab="' +
__e( tab.get('slug') ) +
'" href="#' +
__e( tab.get('href') ) +
'">\n                ' +
__e( tab.get('name') ) +
' <span class="count thin">&#40;' +
__e( tab.get('length') ) +
'&#41;</span>\n            </a>\n        ';
 } ;
__p += '\n\n';
 }) ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/dashboard/DashboardNavigationView.tpl
// module id = 2900
// module chunks = 0